export enum ScheduledRemittanceStatusId {
  Pending = 1,
  Scheduled = 2,
  Editing = 3,
  Past = 4
}
